// extracted by mini-css-extract-plugin
export default {"wrap":"HeaderActions_wrap__XgZUP","nick":"HeaderActions_nick__jxMxM","balance":"HeaderActions_balance__cqg68"};